import { render, staticRenderFns } from "./pbxForm.vue?vue&type=template&id=2c958c6a"
import script from "./pbxForm.vue?vue&type=script&lang=js"
export * from "./pbxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports